import Modal from '../../Common/Modal';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import MaintenanceTable from '../../Common/Maintenance/table';
import { VehicleDowntime } from '@deliveries-app/models';
import Button from '../../Common/Button';

interface MaintenanceModalProps {
  setShowModal: (a: boolean) => void;
  setStartDate: (a: Date) => void;
  setEndDate: (a: Date) => void;
  startDate: Date;
  endDate: Date;
  onDowntimeSubmit: (e: any) => void;
  setDateMaintenance: (a: Date) => void;
  dateMaintenance: Date;
  downtimeList: VehicleDowntime[];
  onDeleteDowntime: (a: number) => void;
  isShow: boolean;
}
const MaintenanceModal = ({
  setShowModal,
  setStartDate,
  setEndDate,
  startDate,
  endDate,
  onDowntimeSubmit,
  downtimeList,
  dateMaintenance,
  setDateMaintenance,
  onDeleteDowntime,
  isShow,
}: MaintenanceModalProps) => {
  return (
    <Modal type="small" closeModal={() => setShowModal(false)} open={isShow}>
      <form onSubmit={onDowntimeSubmit}>
        <div className="mb-4">
          <div className="mb-1 font-bold">Start Date</div>
          <DatePicker
            selected={dateMaintenance}
            onChange={(date) => setDateMaintenance(date)}
            dateFormat="dd-MM-yyyy"
          />
        </div>
        <div className="mb-4">
          <div className="mb-1 font-bold">Start Time</div>
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={15}
            timeCaption="Time"
            dateFormat="h:mm aa"
          />
        </div>
        <div className="mb-4">
          <div className="mb-1 font-bold">End Time</div>
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={15}
            timeCaption="Time"
            dateFormat="h:mm aa"
          />
        </div>
        <div className="flex flex-row justify-end">
          <Button type="submit">Submit</Button>
          <Button type="button" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </div>
        <div className="mt-6">
          <MaintenanceTable
            vehicleDowntime={downtimeList}
            onDelete={onDeleteDowntime}
          />
        </div>
      </form>
    </Modal>
  );
};

export default MaintenanceModal;
